import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { MessagesButton } from "@/components/MessagesButton";
import CustomerBookings from "@/pages/CustomerBookings";
import CustomerServices from "@/pages/CustomerServices";
import CustomerPackages from "@/pages/CustomerPackages";
import SavedServices from "@/pages/SavedServices";
import { CalendarCheck, Wrench, Boxes, Heart } from "lucide-react";

const TABS = ["bookings", "services", "packages", "saved"];

export default function CustomerDashboard() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.includes(sp.get("tab")) ? sp.get("tab") : "bookings";

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-8" data-testid="customer-dashboard">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">Your dashboard</h1>
          <p className="text-muted-foreground mt-1">Bookings, services, packages and saved favorites — all in one place.</p>
        </div>
        <MessagesButton />
      </div>
      <Tabs value={tab} onValueChange={(v) => setSp(v === "bookings" ? {} : { tab: v })} className="mt-6">
        <TabsList className="rounded-sm flex-wrap h-auto">
          <TabsTrigger value="bookings" data-testid="cd-tab-bookings" className="rounded-sm"><CalendarCheck className="w-4 h-4 mr-1.5" />Bookings</TabsTrigger>
          <TabsTrigger value="services" data-testid="cd-tab-services" className="rounded-sm"><Wrench className="w-4 h-4 mr-1.5" />Services</TabsTrigger>
          <TabsTrigger value="packages" data-testid="cd-tab-packages" className="rounded-sm"><Boxes className="w-4 h-4 mr-1.5" />Packages</TabsTrigger>
          <TabsTrigger value="saved" data-testid="cd-tab-saved" className="rounded-sm"><Heart className="w-4 h-4 mr-1.5" />Saved</TabsTrigger>
        </TabsList>
        <TabsContent value="bookings"><CustomerBookings /></TabsContent>
        <TabsContent value="services"><CustomerServices /></TabsContent>
        <TabsContent value="packages"><CustomerPackages /></TabsContent>
        <TabsContent value="saved"><SavedServices /></TabsContent>
      </Tabs>
    </div>
  );
}
